import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";
import Utilities from '@/Utility/Utilities';

export default class PressEnterBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.pressEnter = {
            init: (element: HTMLElement, valueAccessor: () => any) => {
                let val = valueAccessor();
                if (!Utilities.isFunction(val)) {
                    return;
                }

                $(element).keyup((event) => {
                    if (event.keyCode == 13) {
                        val("", event);
                    }
                });
            }
        }
    }
}